module.exports = __webpack_public_path__ + "img/5.f3f07f0.gif";